import { useMemo } from 'react';

import { useAgentManager } from '../providers/AgentProvider';
import { useThreadState } from '../store/useChatStore';

export const useChat = () => {
  const {
    appendUserMessage,
    cancelRun,
    canConsumeMoreCredits,
    isRunning,
    sendMessage,
    sendProgrammaticMessage,
    currentThreadId,
    creditAnalyticsParams,
    onShowPlansModal,
  } = useAgentManager();
  const state = useThreadState(currentThreadId);

  return useMemo(
    () => ({
      appendUserMessage,
      canConsumeMoreCredits,
      cancelRun,
      creditAnalyticsParams,
      currentThreadId,
      isRunning,
      onShowPlansModal,
      sendMessage,
      sendProgrammaticMessage,
      state,
    }),
    [
      appendUserMessage,
      canConsumeMoreCredits,
      cancelRun,
      currentThreadId,
      isRunning,
      sendMessage,
      sendProgrammaticMessage,
      state,
      creditAnalyticsParams,
      onShowPlansModal,
    ],
  );
};
